import { Button } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import {
  DESKTOP_PLATFORM_LABELS,
  detectDesktopPlatform,
  useLatestDesktopRelease,
} from './latestDesktopRelease';

export default function DesktopDownloadButton() {
  const platform = detectDesktopPlatform(navigator);
  const { data: release, isLoading } = useLatestDesktopRelease();

  if (!platform) {
    return <Button disabled>The desktop app is available for Mac and Windows</Button>;
  }

  const installer = release?.installers[platform];

  return (
    <Button
      component="a"
      href={installer?.url}
      loading={isLoading}
      disabled={!installer}
      leftSection={<IconDownload size={16} />}
    >
      Download for {DESKTOP_PLATFORM_LABELS[platform]}
    </Button>
  );
}
